<template>
	<div class="tpl order-wrap">
		<mt-header title="免费预约" fixed>
			<router-link :to="{name:'home'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
		</mt-header>
		<div class="input-list">
			<ul>
				<li>
					<p class="name">姓名</p>
					<p class="value"><input type="text" placeholder="输入姓名" v-model="name"></p>
				</li>
				<li>
					<p class="name">性别</p>
					<p class="value"><input type="text" placeholder="输入性别" v-model="sex"></p>
				</li>
				<li>
					<p class="name">出生年月</p>
					<p class="value"><input type="text" placeholder="输入出生年月" v-model="birthday"></p>
				</li>
				<li>
					<p class="name">电话</p>
					<p class="value"><input type="text" placeholder="输入联系方式" v-model="tel"></p>
					<p class="tips">请预留你的真实号码，平台工作人员会电联和您对接后续事宜</p>
				</li>
			</ul>
			<button @click="submitInfo">立即预约</button>
		</div>
		<div class="introduce">
			<p class="title">大师介绍：</p>
			<div class="content">
				<p>郑惠东，号并非道长。国学学者，上海交大特约讲师，得众家传承，如第四十代全真暗派高功、第四十七代天心等。精于风水、术数、姻缘测算。</p>
				<p>爱情是如此的甜蜜，如何才能让把握现在的幸福,成就一段美好的姻缘，免费姻缘算命，也许可以解开你的缘分面纱，也许千呼万唤始出来，那人却在灯火阑珊处。</p>
				<p>大师分析姻缘，扫除感情障碍</p>
			</div>
			<p class="title">提供服务如下：</p>
			<div class="content">
				<p>1、结合本命姻缘，提供择偶建议</p>
				<p>2、预测结婚年龄，结婚对象的特征</p>
				<p>3、提供脱单秘籍，教你如何俘获对方的心</p>
			</div>
		</div>
	</div>
</template>

<script>
	import GetPosition from '../Common/GetPosition'
	export default {
		name: "order-fortune",
		components:{
			GetPosition
		},
		data() {
			return {
				uid: "",
			  	name:"",
			  	sex:"",
			  	age:"",
			  	birthday:"",
			  	tel:"",
			}
		},
		computed:{
		  	isLight(){
		  		var h = new Date().getHours();
		  		if(h>=6&&h<=18){
		  			return 1;
		  		}else{
		  			return 0;
		  		}
		  	}
		},
		created() {
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "home");
			this.$store.commit("changeTabBarShow", false);
			
			this.getBaseInfo();
		},
		mounted() {
			var _this = this;
			
		},
		methods: {
			getPosition(data){
//				console.log(data);
				this.$store.commit("setNowAdd", data.name);
			},
			getBaseInfo(){
				this.$axios({
					url:"HomePage/AppointmentMasterList",
					method:"post",
					data:{
						uid:this.uid
					}
				}).then(res=>{
					console.log(res);
	  				if(res.data.code==200){
	  					res.data.data.gender==1?this.sex='男':this.sex="女";
	  					this.birthday = res.data.data.age;
	  				}
				}).catch(err=>{
					console.log(err)
				})
		  		
		  	},
		  	submitInfo(){
		  		if(this.name==""){
		  			this.$toast({message:"请填写姓名！",position:"bottom",duration:3000});
		  			return false;
		  		}else if(this.sex==""){
		  			this.$toast({message:"请填写性别！",position:"bottom",duration:3000});
		  			return false;
		  		}else if(this.birthday==""){
		  			this.$toast({message:"请填写生日！",position:"bottom",duration:3000});
		  			return false;
		  		}else  if(!(/^1[34578]\d{9}$/.test(this.tel))){
		  			this.$toast({message:"请正确填写电话号码！",position:"bottom",duration:3000});
		  			return false;
		  		}
		  		this.$axios({
		  			url:"HomePage/AppointmentMaster",
		  			method:"post",
		  			data:{
		  				uid:this.uid,
		  				name:this.name,
		  				gender:this.sex,
		  				age:this.birthday,
		  				phone:this.tel,
		  			}
		  		}).then(res=>{
		  			console.log(res);
	  				this.$toast({message:res.data.msg,position:"bottom",duration:3000});
	  				if(res.code==200){
	  					this.$router.push({
	  						name:"home"
	  					})
	  					
	  				}
		  		}).catch(err=>{
		  			console.log(err)
		  		})
		  	},
		}
	}
</script>

<style scoped>
	.order-wrap{background:#f3f3f3 url(../../assets/img/home/home_cal_res_bg.png) no-repeat;background-size:100% auto;background-position:0 2.5rem;width:100vw;height:calc(100vw * 2.3);padding:0 2.8rem;padding-top: 2.5rem;}
	.input-list{text-align:center;padding-top:1rem;}
	.input-list li{padding-top:1rem;text-align:center;}
	.input-list li .name{font-size:0.9rem;color:#e0d4bf;line-height:1.5rem;}
	.input-list li .value input{width:10.8rem;height:2rem;border-radius:2rem;border:0;outline:0;text-align:center;background:#e0d4bf;color:#5a4c32;}
	.input-list li .tips{font-size:0.72rem;line-height:1.2rem;text-align:left;color:#e0d4bf;margin-top:0.3rem;}
	.input-list button{font-size:0.9rem;width:10.8rem;height:2.2rem;background:none;border:1px solid #e0d4bf;outline:0;border-top-color:rgba(224,212,191,.3);border-radius:4px;color:#e0d4bf;margin-top:2rem;}
	.introduce{color:#e0d4bf;margin-top:1rem;}
	.introduce .title{font-size:0.85rem;line-height:1.5rem;font-weight:bold;}
	.introduce .content{font-size:0.8rem;line-height:1.2rem;}
</style>


// WEBPACK FOOTER //
// src/components/Home/OrderFortune.vue